module.exports = __webpack_public_path__ + "img/WeChat21feae3850314d27cda02473ec748f9a.21feae38.png";